exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-ae0e7818]{position:fixed;z-index:999;padding-top:100px;left:25vw;top:20px;background-color:#fefefe;margin:auto;padding:5px;border:1px solid #888;border-radius:8px;width:50%}h4[data-v-ae0e7818],p[data-v-ae0e7818]{margin-left:20px}.modal-content>h4[data-v-ae0e7818]{padding-left:5px}.modal-content>p[data-v-ae0e7818]{margin:0;padding-left:15px}.modal-default-button[data-v-ae0e7818]{float:right}.error-message[data-v-ae0e7818]{background-color:#fc0;opacity:.9}.info-message[data-v-ae0e7818]{background-color:#add8e6;opacity:.9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ae0e7818","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/messages.vue
// module id = 78
// module chunks = 0